import styled from 'styled-components';

export const Container = styled.div`
  .lista-modelos {
    max-height: 620px;
    overflow-y: auto;
  }

  .modelo-item {
    border: 1px solid #dee2e6;
    border-radius: 4px;
    padding: 8px 10px;
    margin-bottom: 6px;
    cursor: pointer;
    background: #fff;
    transition: all .15s ease;
  }

  .modelo-item:hover {
    border-color: #adb5bd;
    background: #f8f9fa;
  }

  .modelo-item.ativo {
    border-color: #007bff;
    background: #eaf3ff;
  }

  .modelo-item .codmod {
    display: inline-block;
    min-width: 34px;
    text-align: center;
    font-weight: 700;
    font-size: 12px;
    color: #fff;
    background: #6c757d;
    border-radius: 3px;
    padding: 1px 6px;
    margin-right: 8px;
  }

  .modelo-item.ativo .codmod {
    background: #007bff;
  }

  .modelo-item .desmod {
    font-size: 14px;
    font-weight: 600;
  }

  .modelo-item .meta {
    font-size: 11px;
    color: #6c757d;
    margin-top: 3px;
  }

  .nav-tabs .nav-link {
    cursor: pointer;
  }

  .aba-conteudo {
    border: 1px solid #dee2e6;
    border-top: none;
    border-radius: 0 0 4px 4px;
    padding: 15px;
    background: #fff;
  }

  .vazio {
    text-align: center;
    color: #6c757d;
    padding: 40px 15px;
    border: 1px dashed #ced4da;
    border-radius: 4px;
    background: #fff;
  }
`;

export const TabelaItens = styled.table`
  width: 100%;
  margin-bottom: 0;

  th {
    padding: 4px 6px !important;
    font-size: 12px;
    vertical-align: middle !important;
  }

  td {
    padding: 4px 6px !important;
    vertical-align: middle !important;
  }

  .col-ordem  { width: 62px;  text-align: center; }
  .col-numite { width: 52px;  text-align: center; font-size: 12px; color: #6c757d; }
  .col-tipo   { width: 165px; }
  /* Comporta os dois botoes (escala de nota + excluir) na mesma linha, sem
     quebrar para uma segunda altura. */
  .col-acao   { width: 84px;  text-align: center; white-space: nowrap; }

  .col-acao .btn + .btn {
    margin-left: 4px;
  }

  .btn-ordem {
    border: none;
    background: transparent;
    color: #6c757d;
    padding: 0 3px;
    line-height: 1;
    font-size: 14px;
  }

  .btn-ordem:disabled {
    color: #dee2e6;
  }

  .linha-cabecalho td {
    background: #f1f3f5;
  }

`;

export const Botoes = styled.div`
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  button {
    margin-left: 8px;
  }
`;
